import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ICardinal } from "./ICardinal";
import { ICardinalLoadStrategy } from "./ICardinalLoadStrategy";
import { CardinalScriptLoader } from "./CardinalScriptLoader";
import { CardinalConnectivityTester } from "./CardinalConnectivityTester";

export interface ICardinalV2Config {
  url: string;
  integrity: string;
  connectivityTimeout: number;
}

export class CardinalV2Loader implements ICardinalLoadStrategy {
  constructor(
    private scriptLoader: CardinalScriptLoader,
    private connectivityTester: CardinalConnectivityTester,
    private config: ICardinalV2Config,
  ) {}

  load(): Observable<ICardinal> {
    return this.connectivityTester
      .test(this.config.url, this.config.connectivityTimeout)
      .pipe(
        switchMap(() =>
          this.scriptLoader.loadScript(this.config.url, {
            integrity: this.config.integrity,
            crossorigin: "anonymous",
          }),
        ),
      );
  }
}
